import React from 'react';

const Partners = () => (
    <div>
        <h2>Partners Page</h2>
    </div>
);

export default Partners;
